/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a sequence above to see the result.`)
};

const es_revcomp_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una secuencia arriba para ver el resultado.`)
};

const de_revcomp_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie oben eine Sequenz ein, um das Ergebnis zu sehen.`)
};

const nl_revcomp_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak hierboven een sequentie om het resultaat te zien.`)
};

const fr_revcomp_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une séquence ci-dessus pour voir le résultat.`)
};

const it_revcomp_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una sequenza sopra per vedere il risultato.`)
};

const pt_br2_revcomp_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência acima para ver o resultado.`)
};

const pt_revcomp_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência acima para ver o resultado.`)
};

const ja_revcomp_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上に配列を貼り付けると結果が表示されます。`)
};

const zh_revcomp_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在上方粘贴序列以查看结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_hint_empty", locale)
	if (locale === "en") return en_revcomp_hint_empty(inputs)
	if (locale === "es") return es_revcomp_hint_empty(inputs)
	if (locale === "de") return de_revcomp_hint_empty(inputs)
	if (locale === "nl") return nl_revcomp_hint_empty(inputs)
	if (locale === "fr") return fr_revcomp_hint_empty(inputs)
	if (locale === "it") return it_revcomp_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_hint_empty(inputs)
	if (locale === "pt") return pt_revcomp_hint_empty(inputs)
	if (locale === "ja") return ja_revcomp_hint_empty(inputs)
	return zh_revcomp_hint_empty(inputs)
};